import { useState, useMemo, useCallback } from 'react'
import { useDrop } from 'react-dnd'

const filterOptions = (options, filter, canFilter) => {
  return canFilter
    ? options.filter(
        option =>
          option.label.toLowerCase().includes(filter.toLowerCase()) ||
          option.parents?.some(parent => parent.label.toLowerCase().includes(filter.toLowerCase())),
      )
    : options
}

const useList = props => {
  const { canFilter, options, value, onChange, handleDropItems, filter: controlledFilter, setFilter: controlledSetFilter } = props

  const [internalFilter, internalSetFilter] = useState('')
  const filter = controlledFilter !== undefined ? controlledFilter : internalFilter
  const setFilter = controlledSetFilter !== undefined ? controlledSetFilter : internalSetFilter

  const computedOptions = useMemo(() => filterOptions(options, filter, canFilter), [filter, canFilter, options])

  const groupOptionsByParent = useCallback((options) => {
    const grouped = {};
    const labels = {};
    options.forEach(opt => {
      if (Array.isArray(opt.parents) && opt.parents.length > 0) {
        opt.parents.forEach(parent => {
          const parentId = parent.value;
          labels[parentId] = parent.label;
          grouped[parentId] = grouped[parentId] || [];
          grouped[parentId].push(opt);
        });
      } else {
        grouped['ungrouped'] = grouped['ungrouped'] || [];
        grouped['ungrouped'].push(opt);
      }
    });
    return { grouped, labels };
  }, []);

  const handleOptionChange = useCallback(
    accessor => {
      if (value.indexOf(accessor) > -1) {
        onChange(value.filter(v => v !== accessor))
      } else {
        onChange([...value, accessor])
      }
    },
    [value, onChange],
  )

  const checkIsSelected = useCallback(accessor => value.indexOf(accessor) > -1, [value])

  const [, dropRef] = useDrop(
    () => ({
      accept: 'OPTION',
      drop: handleDropItems,
    }),
    [handleDropItems],
  )

  return { filter, setFilter, computedOptions, handleOptionChange, checkIsSelected, dropRef, groupOptionsByParent }
}

export default useList
